export default __webpack_public_path__ + "static/O0235-4b855028b0d7a6db92f268290f856d2f.png";